export default "__VITE_ASSET___Goz1KS0__"